import Commissions from './Commissions'

export default Commissions
